<template>
  <div id="app">
     <!-- 缓存需要保留状态的页面 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不缓存的页面（正常销毁） -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
   
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created(){
    this.getUrlHead()
  },
  methods:{
     //得到各个分类数量
     getUrlHead() {
      let that = this;
      let url = "minio/getHost";
      that.$http
        .get(url)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.$store.commit("imgUrl", res.data);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body,
p,
ul,
li,
a {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
  list-style: none;
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.common-img-outer {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 广告图片外层div设置相对定位 */
.setPositon {
  position: relative;
}
/* 广告图片上的文字提示 */
.adver-words-tip {
  position: absolute;
  top: 3%;
  right: 3%;
  font-size: 12px;
  font-weight: bold;
  color: red;
  opacity: 0.8;
}
/* input:focus {
    border: none;
    box-shadow: none;
} */
/* 登陆样式开始 */

.my-tab .el-tabs__item.is-active,
.my-tab .el-tabs__item:hover {
  color: #f64320;
}
.my-tab .el-tabs__active-bar {
  background-color: #f64320;
}
.login-div .el-input__inner:focus {
  border: 1px solid #f64320;
}
.login-div .my-input .el-input__inner {
  height: 40px;
  line-height: 40px;
  /* margin-bottom: 20px; */
  padding-left: 43px;
}
/* .login-div .yzm .el-input__inner {
    padding-left: 43px;
} */
.login-div .first-input .el-input__inner {
  background: url(./assets/logo/account.png) no-repeat 10px center;
}
.login-div .second-input .el-input__inner {
  background: url(./assets/logo/password.png) no-repeat 10px center;
}
.login-div .first-input .el-input__inner:focus {
  background: url(./assets/logo/account1.png) no-repeat 10px center;
  border: 1px solid #f64320;
}
.login-div .second-input .el-input__inner:focus {
  background: url(./assets/logo/password1.png) no-repeat 10px center;
  border: 1px solid #f64320;
}
/* 登陆样式结束 */

/* 头部 */
/* 第一个头部导航样式开始 */
#topNav .el-menu-item.is-active {
  color: #fff !important;
  /* background-color: #f96142 !important; */
}
.red-title-nav .el-menu .el-menu-item.is-active,
.red-title-nav .el-menu .el-submenu.is-active > .el-submenu__title {
  color: #fff !important;
}
.geNav .el-menu .el-menu-item.is-active,
.geNav .el-menu .el-submenu.is-active > .el-submenu__title {
  color: #303133 !important;
}
.el-menu-black > .el-submenu .el-submenu__title {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
}
.head-input .el-input__inner {
  height: 32px;
  line-height: 32px;
}
/* header .el-input-group__append button.el-button {
    background-color: #f64420;
    color: white;
    padding: 8px 10px;
    border-radius: 0px;
} */
.el-submenu__title {
  padding-right: 0px;
}

.red-down .el-submenu__title i {
  color: #fff;
}
.topIndex .el-menu--horizontal > .el-menu-item.is-active,
.topIndex .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
  color: #fff !important;
}
#topNav .el-menu-item:hover,
#topNav .el-submenu .el-submenu__title:hover {
  background-color: #f96142 !important;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 100px !important;
  /* padding: 10px; */
}
.erweimaSJ {
  height: 100px !important;
}
/* 第一个头部导航样式结束 */

/* .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 40px;
    line-height: 40px;
    border-bottom: 2px solid transparent;
    color: #909399;
} */
/* 首页 */
/* .index .top-carousel {
    height: 500px;
} */
/* .index .top-carousel .el-carousel__item {
    height: 500px;
} */
.index .el-card__body {
  padding: 0px;
}
.acupoint .el-carousel__item {
  height: 400px;
}
/* .top-carousel .el-carousel__container {
    height: 500px;
} */
/* 分页 */
.el-pagination {
  text-align: center;
  padding: 30px 0px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f64420;
  color: #fff;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: white;
}
/* 讲堂详情 */

.input-with-select .el-input__inner {
  border-right: none;
  background-color: #f9f9f9;
  border: none;
}
.indexLoginBottomHead .input-with-select .el-input-group__append {
  border: none;
  background-color: #f64420;
  color: #fff;
}
/* 中草药详情 */
.Herbal-medicine-detail .top-carousel .el-carousel__container {
  width: 100%;
  height: 500px !important;
}
.upArrow .el-submenu__title i {
  display: none !important;
}

.headImg .el-form-item__content {
  margin-left: 0px !important;
  text-align: center;
}
.cancle-margin-left .el-form-item__content {
  margin-left: 30px !important;
}
/* 长按钮公共样式开始 */
.btn {
  width: 145px;
  height: 32px;
  color: #fff;
  padding: 0px;
}
.blue {
  background-color: #40a9e0 !important;
}
.red {
  background-color: #f64420 !important;
}
.grey {
  background-color: #ababab !important;
}
.btn-group .btn1 {
  width: 100px;
  height: 44px;
  font-family: MicrosoftYaHei;
  color: white;
  font-size: 18px;
  color: #ffffff;
}
/* 长按钮公共样式结束 */
/* 小按钮公共样式开始 */
.small-btn,
.small-btn:hover,
.small-btn:focus {
  /* width: 54px; */
  height: 24px;
  border-radius: 2px;
  padding: 0px 10px;
  color: #fff;
}
.btn-medium {
  width: 108px;
  height: 36px;
  padding: 0px;
}
/* 小按钮公共样式结束 */

/* 个人中心公共样式开始 */
.outer-border {
  border: 1px solid #dddddd;
  background-color: #fff;
}
.title-border-bottom {
  border-bottom: solid 1px #dddddd;
  margin: 16px 20px 0px 20px;
}
.b-title {
  padding-bottom: 10px;
  letter-spacing: 0px;
  color: #333333;
  font-size: 14px;
}
/* 个人中心公共样式结束 */
.content-two {
  padding: 40px 20px 0px 20px;
}
/* .c-textarea {
  width: 100%;
}
.c-textarea .el-form-item__content {
  width: 90%;
} */
/* 所有表格公共样式开始 */
.table {
  width: 100%;
}
.table,
.table th,
.table td {
  border: 1px solid #dddddd;
  border-collapse: collapse;
}
.table th,
.table td {
  text-align: center;
}
.table .table-title {
  background-color: #f8f8f8;
}
.margin-left-zero .el-form-item__content {
  margin-left: 0px !important;
}
.table-a {
  padding: 0px 15px 0px 10px;
  background-color: #f64420;
  color: #fff;
  width: 15px;
  line-height: 24px;
}
.border-ten {
  border: 10px solid #f8f8f8;
}
.medinum-kuokao {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  letter-spacing: 2.6px;
}
.intro {
  letter-spacing: 2.2px;
  color: #666666;
  padding: 20px 0px 25px 0px;
  font-size: 14px;
}
.margin-bottom-three {
  margin-bottom: 30px;
}
.my-desc .el-textarea__inner {
  border: none !important;
  height: 40px;
}
/* 所有表格公共样式结束 */

.border-grey {
  border-bottom: 12px solid #eeeeee;
}
.content-small-width {
  width: 1024px;
  margin: 33px auto 43px;
}
.contain {
  /* max-width: 1440px; */
  /* max-width: 80%; */
  width: 1024px;
  margin: 0px auto;
}
.content-width {
  /* max-width: 1440px; */
  /* max-width: 80%; */
  width: 1024px;
  margin: 0 auto;
  padding-top: 30px;
}
/*广告样式 */
.adver-img {
  width: 100%;
  margin-bottom: 20px;
}
/* 标题介绍部分样式 */
.large-title {
  font-size: 30px;
  color: #333333;
  margin-right: 10px;
}
.browse-count {
  font-size: 14px;
  color: #999999;
}
.jiangshi {
  border-bottom: 12px solid #eeeeee;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.jiangshi span {
  font-size: 14px;
  color: #999999;
  margin-right: 20px;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
/* 详细介绍样式 */
.r-title {
  font-size: 22px;
  color: #333333;
  letter-spacing: 2.2px;
  padding: 28px 0px;
}
.r-intro {
  font-size: 16px;
  color: #666666;
  letter-spacing: 1.6px;
  margin-bottom: 30px;
  line-height: 36px;
  text-align: justify;
}
.imgD {
  width: 100%;
  margin-bottom: 30px;
}
/* ul  li样式 */
.l-title {
  background-color: #f64420;
  color: #fff;
  height: 50px;
  line-height: 50px;
  padding: 0 10px 0 15px;
}
.l-title img {
  vertical-align: middle;
}
.l-ul {
  border: solid 1px #ebebeb;
  max-height: 260px;
  overflow: auto;
  margin-bottom: 20px;
}
.l-ul li {
  line-height: 50px;
  /* height: 50px; */
  padding-left: 24px;
  border-bottom: 2px dotted #e9e9e9;
  color: #666666;
  cursor: pointer;
}
.l-ul li:last-child {
  border-bottom: none;
}
.my-page .el-pager .number,
.my-page .el-pager .more {
  display: none !important;
}
.my-page.is-background .btn-next,
.my-page.is-background .btn-prev {
  background-color: #fff;
  border: solid 1px #dddddd;
  padding: 0px 10px;
}
.bg-grey {
  background-color: #f6f6f6;
}
/* .more-search .el-button:hover {
  background-color: #f64420;
  color: white;
  border: 1px solid white;
} */

.right-list {
  border: 2px solid #e9e9e9;
}
.right-list .collection-title {
  background-color: #e9e9e9;
  border-bottom: solid 1px #dddddd;
  color: #333333;
}
.collection-title {
  height: 24px;
  line-height: 24px;
  padding: 13px;
  background-color: #f64420;
  color: #ffffff;
  text-align: left;
  padding-left: 20px;
  cursor: pointer;
}
/* .collection-title img:nth-child(2) {
  margin-left: 80px;
} */
.collection-title img {
  vertical-align: middle;
}
.list-one > div {
  padding: 10px 0px;
  border-bottom: 2px dotted #e9e9e9;
  color: #666666;
  cursor: pointer;
}
.list-one,
.list-two {
  padding: 12px;
}
.adv-list .el-image {
  /* margin-top: 20px; */
  cursor: pointer;
}
.el-tag {
  margin: 0px 10px 10px 0px;
}
.name {
  font-size: 20px;
  color: #333333;
  border-bottom: 1px solid #dddddd;
  padding-bottom: 20px;
  margin-top: 10px;
}
.more-search .el-button {
  padding: 9px 15px;
}
.qd-btn-group {
  text-align: center;
  padding: 10px 0px 0px;
  margin-top: 20px;
  border-top: 1px dotted #888888;
}
.btn-bg-qvxiao {
  color: white;
  border: 1px solid white;
  background-color: #999999;
}
.btn-bg {
  color: white;
  border: 1px solid #f64420;
  background-color: #f64420;
}
.el-menu .el-menu-item {
  padding: 0 10px !important;
}
.select-checked,
.select-checked:focus,
.search-more-down:hover {
  color: white !important;
  border: 1px solid #f64420;
  background-color: #f64420 !important;
}
.no-checked:hover,
.no-checked:focus {
  color: white !important;
  border: 1px solid #f64420;
  background-color: #f64420 !important;
}
.no-checked,
.search-more-down {
  color: #888888;
  background-color: #f8f8f8;
  border: solid 1px #dddddd;
  margin-bottom: 10px;
}
.library-index .el-card__body {
  padding: 0px !important;
}
.search-input,
.search-input .el-input__inner {
  width: 200px;
  height: 33px;
  line-height: 33px;
}
.search-input .el-input__inner:focus {
  border: 1px solid #dcdfe6;
}
.more-search-css:focus,
.more-search-css:hover {
  color: white;
  border: 1px solid #f64420;
  background-color: #f64420;
}
.my-tag .el-tag,
.my-tag .el-tag__close {
  background-color: #fff;
  border: dotted 1px #f64420;
  color: #f64420;
}
.my-tag .el-tag__close:hover {
  background-color: #fff;
  color: #f64420;
}
/* 搜索一级选中 */
.search-parent-selected,
.search-parent-selected:focus,
.search-parent-selected:hover {
  background-color: #fff4f2;
  border: solid 1px #f64420;
  color: #f64420;
}
.search-flex .el-button + .el-button {
  margin-left: 0px;
}
.search-flex .el-button {
  margin-right: 5px;
}
.view-more {
  width: 272px;
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  font-size: 18px;
  text-align: center;
  letter-spacing: 1.8px;
  color: #555555;
  cursor: pointer;
  /* margin-top: 40px; */
}
/* 评论的公共样式开始 */
.jcomment {
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dddddd;
}

.jcomment .prescription {
  font-size: 22px;
  letter-spacing: 2.2px;
  color: #333333;
}
.jcomment .comment-count {
  text-align: right;
  color: #666666;
}
.jcomment-list {
  border-bottom: 1px solid #dddddd;
  padding: 15px 0px;
}
.jcomment-list .jcomment-content {
  margin-top: 12px;
}
.jcomment-list .common-list {
  color: #303030;
}
.jcomment-list .commentime {
  font-size: 14px;
  color: #666666;
}
.jcomment-list .resver {
  float: right;
}
.reverse-jcomment-list {
  margin-left: 50px;
}
.jcomment-list .reverse-name {
  margin: 0px 6px;
  font-weight: bold;
  font-size: 14px;
}
.jcomment-list .inner-comment-view-more {
  font-size: 14px;
  background-color: #f6f6f6;
  padding: 5px;
  margin-top: 20px;
}
.jcomment-list .inner-comment-view-more .el-icon-d-arrow-right {
  margin-left: 10px;
}
.listdetail-adver-outer-img {
  margin-bottom: 10px;
}
.reverse-comment {
  margin: 10px 0px;
}
.comment-button-padding-j .el-input-group__append {
  padding: 0px;
}

/* 评论的公共样式结束 */
.jingXueCarousel .el-carousel__indicators--horizontal {
  display: none !important;
}
.fabu-reverse .el-input-group__append {
  border: none !important;
}
/* 意见反馈样式开始 */
.opionCSS .el-dialog__header {
  text-align: center;
}
.opionCSS .el-dialog__header {
  padding: 10px;
  background-color: red;
}
.opionCSS .el-dialog__title {
  color: #fff;
}
.opionCSS .el-dialog__close {
  color: #fff;
}
/* 意见反馈样式结束 */
/* 文库中,书名竖排显示样式开始 */
.start-left-right-end-shu {
  writing-mode: vertical-lr;
}
/* 文库中,书名竖排显示样式结束 */
.shuxueDetail .r-intro img {
  width: 100% !important;
}

/* 商城悬浮右导航返回顶部 */
.rightNav {
  position: fixed;
  width: 40px;
  height: 100%;
  /* background-color: #cfcfcf; */
  background-color: #bbb;
  z-index: 100;
  top: 0px;
  right: 0;
}
.backTop {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 25px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  left: 0;
}
.rightNav .backTop:hover {
  background: #f64420;
}
.rightNav ul {
  margin-top: 200px;
  width: 40px;
  height: 300px;
}
.rightNav ul li {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 25px;
  text-align: center;
  color: #fff;
  /* background-color: #bbb; */
  margin-top: 20px;
  cursor: pointer;
  position: relative;
}
/* .rightNav ul li:last-child{
    margin-top:300px;
} */
.rightNav ul li:hover {
  background: #f64420;
}

.rightNav ul li p {
  position: absolute;
  background: #f64420;
  right: 40px;
  top: 0;
  width: 120px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}
.rightNav ul li .hover3 {
  width: 120px;
  height: 120px;
  background: #fff;
}
.rightNav ul li .hover3 img {
  width: 100%;
  height: 100%;
}
.add-two-border {
  font-size: 14px !important;
}

.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1; /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue